import React from 'react';
import { Link } from 'react-router-dom';
import { Shield, Mail, MapPin } from 'lucide-react';

const Footer: React.FC = () => {
  return (
    <footer className="bg-[#001a4d] text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 mb-10">

          {/* Left: Company info */}
          <div>
            <div className="flex items-center gap-2 mb-3">
              <div className="w-8 h-8 rounded-lg bg-[#0B8A8F] flex items-center justify-center flex-shrink-0">
                <Shield className="w-4 h-4 text-white" strokeWidth={2.5} />
              </div>
              <span className="font-extrabold text-white text-base">Cyvantix Solutions</span>
            </div>
            <p className="text-white/70 text-sm leading-relaxed">
              Cyvantix Solutions LLC<br />
              Baltimore, MD<br />
              Maryland WOSB
            </p>
          </div>

          {/* Center: Links */}
          <div className="md:text-center">
            <h4 className="font-bold text-white mb-4 text-sm uppercase tracking-wide">Quick Links</h4>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/services" className="text-white/70 hover:text-[#0B8A8F] transition-colors">Services</Link>
              </li>
              <li>
                <Link to="/about" className="text-white/70 hover:text-[#0B8A8F] transition-colors">About</Link>
              </li>
              <li>
                <Link to="/contact" className="text-white/70 hover:text-[#0B8A8F] transition-colors">Contact</Link>
              </li>
            </ul>
          </div>

          {/* Right: Contact */}
          <div className="md:text-right">
            <h4 className="font-bold text-white mb-4 text-sm uppercase tracking-wide">Contact</h4>
            <ul className="space-y-2 text-sm text-white/70">
              <li>
                <a
                  href="https://cyvantixsolutions.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:text-[#0B8A8F] transition-colors"
                >
                  cyvantixsolutions.com
                </a>
              </li>
              <li>
                <a href="mailto:info@cyvantixsolutions.com" className="hover:text-[#0B8A8F] transition-colors flex items-center gap-1.5 md:justify-end">
                  <Mail size={13} />
                  info@cyvantixsolutions.com
                </a>
              </li>
              <li className="flex items-center gap-1.5 md:justify-end">
                <MapPin size={13} />
                Baltimore, MD
              </li>
            </ul>
          </div>

        </div>

        <div className="border-t border-white/15 pt-6 text-center">
          <p className="text-white/50 text-sm">
            © 2026 Cyvantix Solutions LLC · All rights reserved
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
